<template>
  <div
    id="app"
    :style="{ width: `${screenWidth}px`, height: `${screenHeight}px` }"
  >
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
    };
  },
  created() {
  },
  mounted() {
    this.hadleOnsize();
    window.addEventListener("resize", () => {
      this.hadleOnsize();
    });
  },
  watch: {
  },
  methods: {
    hadleOnsize() {
      const that = this;
       window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        that.screenHeight = $(window).height();
     
    },
  },
};
</script>

<style>
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue